module.exports = __webpack_public_path__ + "static/media/brokerage-account.f520558d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/brokerage-account.svg
// module id = 3076
// module chunks = 0